<template>
    <ui-modal
        :title="modalTitle"
        :small="true"
        ref="modal"
    >
        <div class="columns">
            <div class="column is-12">
                <div
                    v-if="projectUpdate"
                    v-html="projectUpdate.description"
                ></div>
            </div>
        </div>

        <footer slot="footer">
            <a
                class="button is-medium mrs"
                @click="closeModal"
            >{{ trans('app.close').titleCase() }}</a>
        </footer>
    </ui-modal>
</template>

<script>

export default {
    data () {
        return {
            projectUpdate: null,
        };
    },

    computed: {
        modalTitle () {
            if (_.isNull(this.projectUpdate)) {
                return '';
            }

            return `Update Details: ${this.projectUpdate.title}`;
        },
    },

    listeners: {
        'open-project-update-details' (projectUpdate = null) {
            this.projectUpdate = _.clone(projectUpdate);
            this.showModal();
        },
    },

    methods: {
        showModal () {
            this.$refs.modal.show();
        },

        closeModal () {
            this.$refs.modal.hide();
            this.projectUpdate = null;
        },
    },
};
</script>
